export default __webpack_public_path__ + "static/media/report.44a9f397.svg";